import { inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICON_CONFIG } from '../domain/icons.types';

export function initializeIcons(): void {
  const iconRegistry = inject(MatIconRegistry);
  const sanitizer = inject(DomSanitizer);

  Object.entries(ICON_CONFIG).forEach(([name, path]) => {
    iconRegistry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(path));
  });
}
